import React from 'react';
import { Button, Result, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Result
        status="403"
        title="403"
        subTitle="Sesi Anda mungkin telah berakhir atau Anda tidak memiliki izin untuk mengakses halaman ini."
        extra={
          <Space>
            <Button type="primary" onClick={() => navigate('/')}>
              Kembali ke Beranda
            </Button>
            <Button type="primary" danger onClick={handleLogout} style={{ marginLeft: '8px' }}>
              Logout
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default AccessDenied;
